var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from 'clsx';
var ERROR_MSG_ACCOUNT_EXISTS_FOR_EMAIL = 'An account already exists for that email address.';
// Parse different error messages to include relevant link
var parseMessage = function (error) {
    if (error.startsWith(ERROR_MSG_ACCOUNT_EXISTS_FOR_EMAIL)) {
        return (_jsxs(_Fragment, { children: [ERROR_MSG_ACCOUNT_EXISTS_FOR_EMAIL, ' ', _jsx("a", __assign({ href: "/account/login", className: "font-medium underline hover:text-squash-700" }, { children: "Please log in" })), ' ', "to your account."] }));
    }
    return error;
};
var MessageAlert = function (_a) {
    var message = _a.message;
    return (_jsx("div", __assign({ className: clsx('border-error-red bg-surface-white', 'w-full border-2 rounded-sm2 p-2xs-gutter text-center') }, { children: _jsx("span", __assign({ className: "text-sm-reg-m md:text-sm-reg-d text-center self-center" }, { children: parseMessage(message) })) })));
};
export default MessageAlert;
